import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import { useSimulationUndo, useSimulationGrid, useSimulationVBC, useSimulationConfig, useSimulationCalculations } from '../../../../hooks/simulation';
import UndoButton from '../common/UndoButton';
import RedoButton from '../common/RedoButton';
import DayTime from '../../../common/DayTimeWrapper'
import { APPROVED_STATUS, defaultPageSize, EMPTY_DATA, OPERATIONS, SURFACETREATMENT, SIMULATION_MAX_DIGITS_AFTER_DECIMAL } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { runVerifyExchangeRateSimulation, setExchangeRateListBeforeDraft, setRawmaterialsEffectiveDate } from '../../actions/Simulation';
import { Fragment } from 'react';
import RunSimulationDrawer from '../RunSimulationDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import Simulation from '../Simulation';
import VerifySimulation from '../VerifySimulation';
import _, { debounce } from 'lodash'
import { PaginationWrapper } from '../../../common/commonPagination';
import ReactExport from 'react-export-excel';
import { APPLICABILITY_BOP_NON_ASSOCIATED_SIMULATION, APPLICABILITY_BOP_SIMULATION, APPLICABILITY_MACHINE_RATES_SIMULATION, APPLICABILITY_OPERATIONS_SIMULATION, APPLICABILITY_PART_SIMULATION, APPLICABILITY_RAWMATERIAL_SIMULATION, APPLICABILITY_RM_SIMULATION, APPLICABILITY_SURFACE_TREATMENT_SIMULATION, EXCHANGE_IMPACT_DOWNLOAD_EXCEl } from '../../../../config/masterData';
import { getCurrencySelectList } from '../../../../actions/Common';
import RMImportListing from '../../../masters/material-master/RMImportListing';
import { setFilterForRM } from '../../../masters/actions/Material';
import BOPImportListing from '../../../masters/bop-master/BOPImportListing';
import WarningMessage from '../../../common/WarningMessage';
import DatePicker from "react-datepicker";
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import TooltipCustom from '../../../common/Tooltip';
import { simulationContext } from '..';
import LoaderCustom from '../../../common/LoaderCustom';
import OperationListing from '../../../masters/operation/OperationListing';
import MachineRateListing from '../../../masters/machine-master/MachineRateListing';
import RMIndexationSimulationListing from './RMIndexationSimulationListing';
import { getMinDate } from '../../SimulationUtils';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter } from '../../../../helper/simulationValidation';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const gridOptions = {

};
function ERSimulation(props) {

    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};

    const { list, isbulkUpload, isImpactedMaster, costingAndPartNo, tokenForMultiSimulation } = props

    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [showMainSimulation, setShowMainSimulation] = useState(false)
    const [isDisable, setIsDisable] = useState(false)
    const [noData, setNoData] = useState(false);
    const [largestDate, setLargestDate] = useState(new Date());
    const [showRMMasterList, setShowRMMasterList] = useState(false);
    const [showBOPMasterList, setShowBOPMasterList] = useState(false);
    const [effectiveDate, setEffectiveDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false);
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [showTooltip, setShowTooltip] = useState(false)
    const [fromListData, setFromListData] = useState('')
    const [toListData, setToListData] = useState('')
    const [showOperationsList, setShowOperationsList] = useState(false);
    const [showMachineRatesList, setShowMachineRatesList] = useState(false);
    const [showSurfaceTreatmentList, setShowSurfaceTreatmentList] = useState(false);
    const [showRawMaterialsList, setShowRawMaterialsList] = useState(false);
    const { isMasterAssociatedWithCosting } = useSelector(state => state.simulation)
    const [minDate, setMinDate] = useState('')

    const dispatch = useDispatch()

    // ============================================================================
    // COMMON HOOKS - Grid operations and undo/redo
    // ============================================================================

    // CRITICAL: Define getRowId function ONCE and use it in both hooks
    const getRowId = useCallback((row) => row.ExchangeRateId || row.FromCurrency + row.ToCurrency, []);

    // Grid hook - handles grid API, pagination, and row operations
    const {
        gridApi,
        findNodeByRowId,
        onGridReady: commonOnGridReady
    } = useSimulationGrid({
        getRowId,  // Pass the same getRowId to grid hook
        defaultPageSize: defaultPageSize,
        onGridReadyCallback: (params) => {
            params.api.paginationGoToPage(0);
            window.screen.width >= 1260 && params.api.sizeColumnsToFit();
            setTimeout(() => {
                setShowTooltip(true)
            }, 100);
        }
    });

    const onGridReady = (params) => {
        commonOnGridReady(params);
    };

    // Undo hook - handles undo/redo functionality
    const {
        saveUndoState,
        handleUndo: originalHandleUndo,
        handleRedo,
        undoCount,
        redoCount,
        canUndo,
        canRedo
    } = useSimulationUndo({
        gridApi,
        findNodeByRowId,
        disabled: isImpactedMaster || isbulkUpload,
        getRowId,  // Use the same getRowId function
        enableKeyboardShortcuts: true,
        updateListData: (rowId, restoredData) => {
            // Find and update the item in the list array
            const itemIndex = list.findIndex(item => getRowId(item) === rowId);
            if (itemIndex !== -1) {
                // Update all properties from restoredData
                Object.keys(restoredData).forEach(key => {
                    list[itemIndex][key] = restoredData[key];
                });
            }
        }
    });

    // Wrap handleUndo to add grid refresh
    const handleUndo = useCallback(() => {
        originalHandleUndo();
        if (gridApi) {
            gridApi.redrawRows();
        }
    }, [originalHandleUndo, gridApi]);

    // VBC hook - handles VBC/ZBC/CBC costing type detection
    // Note: Exchange Rate simulation doesn't use VBC/ZBC/CBC, but hook is available if needed
    const {
        isZBCRow, // eslint-disable-line no-unused-vars
        isVBCRow, // eslint-disable-line no-unused-vars
        isCBCRow, // eslint-disable-line no-unused-vars
        getRowCostingType, // eslint-disable-line no-unused-vars
        isRowVBC, // eslint-disable-line no-unused-vars
        shouldShowConditionCostColumn // eslint-disable-line no-unused-vars
    } = useSimulationVBC({
        list,
        ZBCTypeId: null,  // Exchange Rate doesn't use ZBC
        VBCTypeId: null,  // Exchange Rate doesn't use VBC
        CBCTypeId: null   // Exchange Rate doesn't use CBC
    });

    // Config hook - handles configuration and decimal formatting
    const {
        decimalPlaces, // eslint-disable-line no-unused-vars
        formatNumber, // eslint-disable-line no-unused-vars
        isVisible, // eslint-disable-line no-unused-vars
        config // eslint-disable-line no-unused-vars
    } = useSimulationConfig('NoOfDecimalForPrice');

    // Calculations hook - common calculation helpers
    const {
        checkNull, // eslint-disable-line no-unused-vars
        calculateNetLandedCost, // eslint-disable-line no-unused-vars
        calculateBasicPrice, // eslint-disable-line no-unused-vars
        calculatePercentageChange, // eslint-disable-line no-unused-vars
        applyPercentageToBase // eslint-disable-line no-unused-vars
    } = useSimulationCalculations();

    const columnWidths = {

        Currency: showCompressedColumns ? 50 : 190,
        CostingNumber: showCompressedColumns ? 90 : 190,
        PartNumber: showCompressedColumns ? 100 : 190,
        BankRate: showCompressedColumns ? 100 : 190,
        BankCommissionPercentage: showCompressedColumns ? 100 : 190,
        CustomRate: showCompressedColumns ? 100 : 135,
        CurrencyExchangeRate: showCompressedColumns ? 100 : 120,
        NewCurrencyExchangeRate: showCompressedColumns ? 100 : 120,
        OldExchangeRate: showCompressedColumns ? 100 : 190,
        NewExchangeRate: showCompressedColumns ? 100 : 190,
        EffectiveDate: showCompressedColumns ? 100 : 190,
        ExchangeRateId: showCompressedColumns ? 100 : 190,

    };
    useEffect(() => {
        dispatch(getCurrencySelectList(() => { }))
        list && list?.forEach(item => {
            if (/* !getConfigurationKey().IsExchangeRateEditableForSimulation|| */item?.NewExchangeRateId === null) {
                //if (Number(item?.NewCurrencyExchangeRate) === Number(0)) {
                item.NewCurrencyExchangeRate = item.CurrencyExchangeRate
                //}
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list])
    useEffect(() => {
        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showverifyPage])
    useEffect(() => {
        const entryWithLargestDate = _.maxBy(list, entry => new Date(entry.EffectiveDate));
        setLargestDate(entryWithLargestDate?.EffectiveDate)
    }, [list])
    useEffect(() => {
        if (props?.list.length > 0) {
            let tempList = [...list]
            const minDate = getMinDate(tempList);
            setMinDate(minDate?.EffectiveDate); // This will update the minDate for the DatePicker
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list])
    const { selectedMasterForSimulation } = useSelector(state => state.simulation)
    const { simulationApplicability } = useSelector(state => state.simulation)
    const { selectedVendorForSimulation, selectedCustomerSimulation } = useSelector(state => state.simulation)
    const currencySelectList = useSelector(state => state.comman.currencySelectList)

    const cancelVerifyPage = () => {

        setShowVerifyPage(false)
    }

    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        if (cell != null) {
            const date = DayTime(cell);
            if (date.isValid()) {
                const formattedDate = date.format('DD/MM/YYYY');
                return <span title={formattedDate}> {formattedDate}</span>;
            } else {
                // Fallback: display original value
                const cellStr = String(cell);
                return <span title={cellStr}> {cellStr}</span>;
            }
        }
        return '';
    }
    const newERFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        cell && value ? checkForDecimalAndNull(cell, getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(row.NewExchangeRate, getConfigurationKey().NoOfDecimalForPrice)
                        :
                        <span className={`${!isbulkUpload ? 'form-control' : ''}`} >{cell && value ? checkForDecimalAndNull(cell, SIMULATION_MAX_DIGITS_AFTER_DECIMAL) : checkForDecimalAndNull(row.CurrencyExchangeRate, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)} </span>
                }
            </>
        )
    }

    const oldERFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        cell && value ? checkForDecimalAndNull(cell, getConfigurationKey().NoOfDecimalForPrice) : checkForDecimalAndNull(row.OldExchangeRate, getConfigurationKey().NoOfDecimalForPrice)
                        :

                        <span className={`${!isbulkUpload ? 'form-control' : ''}`} >{cell && value ? checkForDecimalAndNull(cell, SIMULATION_MAX_DIGITS_AFTER_DECIMAL) : checkForDecimalAndNull(row.CurrencyExchangeRate, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)} </span>
                }
            </>
        )
    }

    const costFormatter = (props) => {

        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (!row.NewBasicRate || row.BasicRate === row.NewBasicRate || row.NewBasicRate === '') return checkForDecimalAndNull(cell, getConfigurationKey().NoOfDecimalForPrice)
        const tempA = preciseAdd(Number(row.NewBasicRate), checkForNull(row.RMFreightCost), checkForNull(row.RMShearingCost));
        const classGreen = (tempA > row.NetLandedCost) ? 'red-value form-control' : (tempA < row.NetLandedCost) ? 'green-value form-control' : 'form-class'
        return cell != null ? <span className={classGreen}>{checkForDecimalAndNull(cell, getConfigurationKey().NoOfDecimalForPrice)}</span> : ''
    }

    /**
  * @method beforeSaveCell
  * @description CHECK FOR ENTER NUMBER IN CELL using common validation
  */
    const beforeSaveCell = (cellValue, props, type) => {
        return validateRevisedRate(cellValue, props, type || 'exchangeRate');
    }


    const cancel = () => {
        list && list.map((item) => {
            item.NewCurrencyExchangeRate = undefined
            return null
        })
        setShowMainSimulation(true)
    }

    const cancelImportList = () => {
        setShowRMMasterList(false)
        setShowBOPMasterList(false)
        setShowOperationsList(false)
        setShowMachineRatesList(false)
        setShowRawMaterialsList(false)
        setShowSurfaceTreatmentList(false)
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)

    }

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
    };

    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }

    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text'>Revised {!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"exchangesdRate-tooltip"}></i>}</span>
            </div>
        );
    };

    const newRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        if (isImpactedMaster) {
            return checkForDecimalAndNull(row.NewCurrencyExchangeRate, getConfigurationKey().NoOfDecimalForPrice);
        }

        const newValue = cell || row?.NewCurrencyExchangeRate;
        const oldValue = row?.CurrencyExchangeRate;
        const displayValue = cell ? Number(cell) : Number(row.NewCurrencyExchangeRate);

        return (
            <PriceComparisonSpan
                newValue={newValue}
                oldValue={oldValue}
                costingTypeId={row?.CostingTypeId}
                className={!isbulkUpload ? 'form-control' : ''}
                id={`newCurrencyExchangeRate-${props.rowIndex}`}
                title={displayValue}
            >
                {displayValue}
            </PriceComparisonSpan>
        )
    }

    const oldRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row.CurrencyExchangeRate, getConfigurationKey().NoOfDecimalForPrice) :
                        <span
                            id={`newCurrencyExchangeRate-${props.rowIndex}`}
                            className={`${!isbulkUpload ? 'form-control' : ''}`}
                            title={cell ? checkForDecimalAndNull(cell, SIMULATION_MAX_DIGITS_AFTER_DECIMAL) : checkForDecimalAndNull(row.NewCurrencyExchangeRate, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}
                        >
                            {cell ? checkForDecimalAndNull(cell, SIMULATION_MAX_DIGITS_AFTER_DECIMAL) : checkForDecimalAndNull(row.NewCurrencyExchangeRate, SIMULATION_MAX_DIGITS_AFTER_DECIMAL)}
                        </span>
                }
            </>
        )
    }

    const frameworkComponents = {
        effectiveDateRenderer: effectiveDateFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newERFormatter: newERFormatter,
        oldERFormatter: oldERFormatter,
        oldRateFormatter: oldRateFormatter,
        nullHandler: props.nullHandler && props.nullHandler,
        revisedBasicRateHeader: revisedBasicRateHeader,
        newRateFormatter: newRateFormatter
    };

    const resetState = () => {
        gridOptions.columnApi.resetColumnState();
        gridOptions.api.setFilterModel(null);
    }
    const verifySimulation = debounce(() => {
        /**********POST METHOD TO CALL HERE AND AND SEND TOKEN TO VERIFY PAGE ****************/
        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }
        let count = 0
        let listData = []

        list && list?.map((item) => {
            if (checkForNull(item?.NewCurrencyExchangeRate) !== checkForNull(item?.CurrencyExchangeRate)) {
                count = count + 1
                listData.push(item)

            }
            return null
        })

        setShowTooltip(false)

        if (count === 0) {
            Toaster.warning("Please change the Exchange rate and proceed to the next page.")
            return false
        }

        setIsDisable(true)
        setShowTooltip(false)

        dispatch(createMultipleExchangeRate(listData, currencySelectList, effectiveDate, res => {
            if (res?.length === listData?.length) {
                let obj = {}
                obj.SimulationTechnologyId = selectedMasterForSimulation.value
                obj.LoggedInUserId = loggedInUserId()
                obj.EffectiveDate = DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                obj.SimulationIds = tokenForMultiSimulation
                obj.SimulationHeadId = list[0]?.CostingHeadId
                obj.SimulationExchangeRates = res
                obj.IsExchangeRateSimulation = true

                dispatch(runVerifyExchangeRateSimulation(obj, res => {
                    setIsDisable(false)
                    if (res?.data?.Result) {
                        setToken(res.data.Identity)
                        setShowVerifyPage(true)
                    }
                }))
            } else {
                setIsDisable(false)
            }
        }))
    }, 500)

    const selectRM = debounce(() => {
        if (simulationApplicability?.value === 'RM' && !isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }
        // Check if user has made any edits
        // if (!hasUserMadeEdits) {
        //     Toaster.warning(`Please change the Exchange rate and proceed to the next page to select ${simulationApplicability?.label}`);
        //     return false;
        // }
        let count = 0
        let listData = []
        let fromListData = ''
        let toListData = ''
        let hasValidEdits = false;

        list && list?.map((item) => {
            if (item.NewExchangeRateId === null &&
                checkForNull(item?.NewCurrencyExchangeRate) === checkForNull(item?.CurrencyExchangeRate)) {
                hasValidEdits = true;
                count = count + 1;
                // listData.push(item);
                // fromListData = fromListData ? `${fromListData},${item.FromCurrency}` : item.FromCurrency;
                // toListData = toListData ? `${toListData},${item.ToCurrency}` : item.ToCurrency;
            }
            listData.push(item);
            fromListData = fromListData ? `${fromListData},${item.FromCurrency}` : item.FromCurrency;
            toListData = toListData ? `${toListData},${item.ToCurrency}` : item.ToCurrency;


            return null;
        });
        if (/* !hasUserMadeEdits ||  */hasValidEdits) {

            Toaster.warning(`Please change the Exchange rate and proceed to the next page to select ${simulationApplicability?.label}`);
            return false;
        }
        setFromListData(fromListData)
        setToListData(toListData)

        setShowTooltip(false)

        // if (count === 0) {
        //     Toaster.warning(`Please change the Exchange rate and proceed to the next page to select ${simulationApplicability?.label}`)
        //     return false
        // }

        dispatch(setExchangeRateListBeforeDraft(listData))
        dispatch(setFilterForRM({ costingHeadTemp: '', plantId: '', RMid: '', RMGradeid: '', Vendor: selectedVendorForSimulation?.label, VendorId: selectedVendorForSimulation?.value, CustomerId: selectedCustomerSimulation?.value, Currency: _.map(listData, 'Currency') }))
        switch (simulationApplicability?.value) {
            case APPLICABILITY_RM_SIMULATION:
                setShowRMMasterList(true);
                break;
            case APPLICABILITY_BOP_SIMULATION:
            case APPLICABILITY_BOP_NON_ASSOCIATED_SIMULATION:
                setShowBOPMasterList(true);
                break;
            case APPLICABILITY_OPERATIONS_SIMULATION:
                setShowOperationsList(true);
                break;
            case APPLICABILITY_MACHINE_RATES_SIMULATION:
                setShowMachineRatesList(true);
                break;
            case APPLICABILITY_SURFACE_TREATMENT_SIMULATION:
                setShowSurfaceTreatmentList(true);
                break;
            case APPLICABILITY_RAWMATERIAL_SIMULATION:
                setShowRawMaterialsList(true);
                break;
            default:
        }
    }, 500)

    const onBtExport = () => {
        return returnExcelColumn(EXCHANGE_IMPACT_DOWNLOAD_EXCEl, list)
    };
    // Custom valueSetter to capture old value BEFORE AG Grid updates the node
    const exchangeRateValueSetter = useCallback((params) => {
        const { newValue, data, node } = params;

        // Save old row data BEFORE AG Grid updates it
        const oldRowData = JSON.parse(JSON.stringify(data));

        // Use the validation-enabled value setter from helper
        const result = valueSetter(params, 'exchangeRate');

        // After validation passes, save undo state with the old data
        if (result && oldRowData) {
            saveUndoState(oldRowData, 'Exchange rate changed');
        }

        return result;
    }, [saveUndoState]);

    const onCellValueChanged = (params) => {
        const rowData = params?.data;

        // Update the list array to match the grid node
        if (rowData && params.column.colId === 'NewCurrencyExchangeRate') {
            const itemIndex = list.findIndex(item => getRowId(item) === getRowId(rowData));
            if (itemIndex !== -1) {
                list[itemIndex].NewCurrencyExchangeRate = params?.value;
            }
        }

        // Redraw rows to update visual state
        if (gridApi) {
            gridApi.redrawRows();
        }
    };

    const returnExcelColumn = (data = [], TempData) => {

        let temp = []
        TempData && TempData.map((item) => {
            item.EffectiveDate = (item.EffectiveDate)?.slice(0, 10)
            temp.push(item)
            return null
        })

        return (
            <ExcelSheet data={temp} name={'Exchange Rate Data'}>
                {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }

    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        dispatch(setRawmaterialsEffectiveDate(date))
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }

    return (
        <div>
            {!showRMMasterList && !showBOPMasterList && !showOperationsList && !showMachineRatesList && !showSurfaceTreatmentList && !showRawMaterialsList && <div className={`ag-grid-react`}>

                {showTooltip && !isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"exchangesdRate-tooltip"} >{"To edit revised exchange rate please double click on the field."}</Tooltip>}
                {

                    (!showverifyPage && !showMainSimulation) &&
                    <Fragment>

                        <Row>
                            <Col className="add-min-height mb-3 sm-edit-page">
                                <div className={`ag-grid-wrapper height-width-wrapper reset-btn-container ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                    <div className="ag-grid-header d-flex align-items-center justify-content-between">
                                        <div className='d-flex align-items-center'>
                                            <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            {isImpactedMaster && <ExcelFile filename={'Impacted Master Data'} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile>}
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            {!isImpactedMaster && !isbulkUpload && (
                                                <>
                                                    <UndoButton
                                                        onUndo={handleUndo}
                                                        disabled={!canUndo}
                                                        undoCount={undoCount}
                                                    />
                                                    <RedoButton
                                                        onRedo={handleRedo}
                                                        disabled={!canRedo}
                                                        redoCount={redoCount}
                                                    />
                                                </>
                                            )}
                                            {!isImpactedMaster && <button type="button" id="simulation-back" className={"apply back_simulationPage mr-2"} onClick={cancel} disabled={isDisable}> <div className={'back-icon'}></div>Back</button>}
                                            <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {render ? <LoaderCustom customClass="loader-center" /> : <AgGridReact
                                            floatingFilter={true}
                                            style={{ height: '100%', width: '100%' }}
                                            defaultColDef={defaultColDef}
                                            domLayout='autoHeight'
                                            // columnDefs={c}
                                            rowData={list}
                                            pagination={true}
                                            paginationPageSize={defaultPageSize}
                                            onGridReady={onGridReady}
                                            gridOptions={gridOptions}
                                            noRowsOverlayComponent={'customNoRowsOverlay'}
                                            noRowsOverlayComponentParams={{
                                                title: EMPTY_DATA,
                                            }}
                                            frameworkComponents={frameworkComponents}
                                            stopEditingWhenCellsLoseFocus={true}
                                            rowSelection={'multiple'}
                                            suppressRowClickSelection={true}
                                            onFilterModified={onFloatingFilterChanged}
                                            enableBrowserTooltips={true}
                                            onCellValueChanged={onCellValueChanged}


                                        >
                                            {!isImpactedMaster && <AgGridColumn field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>}
                                            <AgGridColumn field="FromCurrency" headerName="From Currency" minWidth={135}></AgGridColumn>
                                            <AgGridColumn field="ToCurrency" headerName="To Currency" minWidth={135}></AgGridColumn>
                                            {/* <AgGridColumn field="Currency" editable='false' headerName="Currency" minWidth={columnWidths?.Currency}></AgGridColumn> */}
                                            {costingAndPartNo && <AgGridColumn field="CostingNumber" headerName="Costing No" minWidth={columnWidths?.CostingNumber}></AgGridColumn>}
                                            {costingAndPartNo && <AgGridColumn field="PartNumber" tooltipField='PartNumber' headerName="Part No" minWidth={columnWidths?.PartNumber}></AgGridColumn>}
                                            <AgGridColumn field="BankRate" editable='false' headerName="Bank Rate" minWidth={columnWidths?.BankRate}></AgGridColumn>
                                            <AgGridColumn suppressSizeToFit="true" editable='false' field="BankCommissionPercentage" headerName="Bank Commission % " minWidth={columnWidths?.BankCommissionPercentage}></AgGridColumn>
                                            <AgGridColumn field="CustomRate" editable='false' headerName="Custom Rate" minWidth={columnWidths?.CustomRate}></AgGridColumn>
                                            {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn field="ExchangeRateSourceName" headerName="Exchange Rate Source" minWidth={135}></AgGridColumn>}
                                            {!isImpactedMaster && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" minWidth={240} headerName="Exchange Rate" marryChildren={true} pinned='right' >
                                                <AgGridColumn minWidth={columnWidths?.CurrencyExchangeRate} field="CurrencyExchangeRate" tooltipField='CurrencyExchangeRate' editable='false' headerName="Existing" cellRenderer='oldRateFormatter' colId="CurrencyExchangeRate" suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                <AgGridColumn minWidth={columnWidths?.NewCurrencyExchangeRate} field="NewCurrencyExchangeRate" tooltipField="NewCurrencyExchangeRate" valueGetter='data.NewCurrencyExchangeRate' editable={(params) => {
                                                    return !isImpactedMaster &&
                                                        getConfigurationKey()?.IsExchangeRateEditableForSimulation &&
                                                        !params?.data?.NewExchangeRateId;
                                                }} headerName="Revised" cellRenderer='newRateFormatter' colId='NewCurrencyExchangeRate' headerComponent={'revisedBasicRateHeader'} suppressSizeToFit={true} cellClass={(params) => {
                                                    const isEditable = !isImpactedMaster &&
                                                        getConfigurationKey()?.IsExchangeRateEditableForSimulation &&
                                                        !params?.data?.NewExchangeRateId;
                                                    return isEditable ? '' : 'disabled-cell';
                                                }} valueSetter={exchangeRateValueSetter} pinned='right'></AgGridColumn>
                                            </AgGridColumn>}

                                            {isImpactedMaster && <>
                                                <AgGridColumn suppressSizeToFit="true" field="OldExchangeRate" headerName={`Existing Exchange Rate`} minWidth={columnWidths?.OldExchangeRate}></AgGridColumn>
                                                <AgGridColumn suppressSizeToFit="true" field="NewExchangeRate" headerName={`Revised Exchange Rate`} minWidth={columnWidths?.NewExchangeRate}></AgGridColumn>
                                            </>}
                                            {props.children}
                                            <AgGridColumn field="EffectiveDate" headerName="Effective Date" editable='false' minWidth={columnWidths?.EffectiveDate} cellRenderer='effectiveDateRenderer'></AgGridColumn>
                                            <AgGridColumn field="ExchangeRateId" hide={true}></AgGridColumn>

                                        </AgGridReact>}

                                        {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        {!isImpactedMaster &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    <div className="d-flex align-items-center">
                                        {(simulationApplicability?.value === APPLICABILITY_PART_SIMULATION || simulationApplicability?.value === APPLICABILITY_RAWMATERIAL_SIMULATION) ? (
                                            <>
                                                <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                                    <DatePicker
                                                        name="EffectiveDate"
                                                        selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                                        id='EffectiveDate'
                                                        onChange={handleEffectiveDateChange}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode='select'
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select effective date"
                                                        className="withBorder"
                                                        autoComplete={"off"}
                                                        disabledKeyboardNavigation
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        minDate={new Date(largestDate)}
                                                    />
                                                </div>
                                                {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                                {simulationApplicability?.value === APPLICABILITY_PART_SIMULATION ? (
                                                    <button
                                                        onClick={verifySimulation}
                                                        type="submit"
                                                        className="user-btn mr5 save-btn verifySimulation"
                                                        id={"verify-btn"}
                                                        disabled={isDisable}
                                                        title={
                                                            isDisable ? "Simulation is running..." :
                                                            !isEffectiveDateSelected ? "Please select an effective date" :
                                                            "Click to verify simulation"
                                                        }
                                                    >
                                                        <div className={"Run-icon"}>
                                                        </div>{" "}
                                                        {"Verify"}
                                                    </button>
                                                ) : (
                                                    <>
                                                        <TooltipCustom id={"next-button"} disabledIcon={true} tooltipText={`Select the ${simulationApplicability?.label} on next page.`} />
                                                        <button onClick={selectRM} type="button" className="user-btn mr5 next-icon" disabled={isDisable} id={"next-button"}>
                                                            <div>
                                                            </div>{" "}
                                                            Next
                                                        </button>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <TooltipCustom id={"next-button"} disabledIcon={true} tooltipText={`Select the ${simulationApplicability?.label} on next page.`} />
                                                <button onClick={selectRM} type="button" className="user-btn mr5 next-icon" disabled={isDisable} id={"next-button"}>
                                                    <div>
                                                    </div>{" "}
                                                    Next
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Row>
                        }
                    </Fragment>

                }
                {
                    showverifyPage &&
                    <VerifySimulation isExchangeRate={true} token={token} cancelVerifyPage={cancelVerifyPage} />
                }

                {
                    showMainSimulation && <Simulation isRMPage={true} />
                }
                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
            </div>}
            {showRMMasterList && <RMImportListing
                isSimulation={true}
                isMasterSummaryDrawer={false}
                //   apply={editTable}
                //    objectForMultipleSimulation={obj} 
                //    selectionForListingMasterAPI={selectionForListingMasterAPI} 
                //    changeSetLoader={changeSetLoader} 
                //    changeTokenCheckBox={changeTokenCheckBox} 
                //    isReset={isReset} 
                ListFor='simulation'
                approvalStatus={APPROVED_STATUS}
                // stopUnrequiredCalls={true}
                fromListData={fromListData}
                toListData={toListData}
                isFromVerifyPage={true}
                cancelImportList={cancelImportList}
                vendorLabel={props?.vendor}
                FromExchangeRate={true}
                minDate={minDate}


            />}
            {showBOPMasterList &&
                <BOPImportListing
                    isSimulation={true}
                    isMasterSummaryDrawer={false}
                    // technology={technology.value}
                    // objectForMultipleSimulation={obj}
                    // apply={editTable}
                    // selectionForListingMasterAPI={selectionForListingMasterAPI}
                    // changeSetLoader={changeSetLoader}
                    // changeTokenCheckBox={changeTokenCheckBox}
                    // isReset={isReset}
                    ListFor={isMasterAssociatedWithCosting ? 'simulation' : 'master'}
                    isBOPAssociated={isMasterAssociatedWithCosting ? true : false}
                    approvalStatus={APPROVED_STATUS}
                    // callBackLoader={callBackLoader}  
                    fromListData={fromListData}
                    toListData={toListData}
                    isFromVerifyPage={true}
                    cancelImportList={cancelImportList}
                    vendorLabel={props?.vendor}
                    FromExchangeRate={true}
                    minDate={minDate}


                />}
            {(showOperationsList || showSurfaceTreatmentList) && (
                <OperationListing
                    isSimulation={true}
                    isMasterSummaryDrawer={false}
                    ListFor={'simulation'}
                    approvalStatus={APPROVED_STATUS}
                    isFromVerifyPage={true}
                    cancelImportList={cancelImportList}
                    selectionForListingMasterAPI={props?.selectionForListingMasterAPI}
                    isOperationST={showSurfaceTreatmentList ? SURFACETREATMENT : OPERATIONS}
                    fromListData={fromListData}
                    toListData={toListData}
                    vendorLabel={props?.vendor}
                    FromExchangeRate={true}
                    minDate={minDate}



                />
            )}

            {showMachineRatesList && (
                <MachineRateListing
                    isSimulation={true}
                    isMasterSummaryDrawer={false}
                    ListFor={'simulation'}
                    approvalStatus={APPROVED_STATUS}
                    isFromVerifyPage={true}
                    cancelImportList={cancelImportList}
                    selectionForListingMasterAPI={props?.selectionForListingMasterAPI}
                    fromListData={fromListData}
                    toListData={toListData}
                    vendorLabel={props?.vendor}
                    FromExchangeRate={true}
                    minDate={minDate}




                />
            )}
            {showRawMaterialsList && (
                <RMIndexationSimulationListing
                    isSimulation={true}
                    isMasterSummaryDrawer={false}
                    ListFor={'simulation'}
                    approvalStatus={APPROVED_STATUS}
                    isFromVerifyPage={true}
                    cancelImportList={cancelImportList}
                    fromListData={fromListData}
                    toListData={toListData}
                    effectiveDate={effectiveDate}
                    isEffectiveDateSelected={isEffectiveDateSelected}
                    minDate={minDate}
                    vendorLabel={props?.vendor}
                    FromExchangeRate={true}
                    masterId={props?.masterId}


                />
            )}
        </div >
    );
}

export default ERSimulation;